import { getRecordType } from '@xbcb/core';
import { RecordType } from '@xbcb/shared-types';

export const isWorkOrderCuDe = (workOrderId?: string): boolean => {
  if (!workOrderId) return false;
  return getRecordType(workOrderId) === RecordType.CUSTOMS_DECLARATION;
};
